import React from "react";

const FTFRPricing = ({ title, descriptionMain, rows, descriptionNote }) => {
  return (
    <section className="ftfr-pricing-section">
      <div className="container">
        <h2
          className="ftfr-pricing-title text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <p
          className="ftfr-pricing-main"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
        >
          {descriptionMain}
        </p>

        <div
          className="table-responsive"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="ftfr-pricing-table">
            <thead>
              <tr>
                <th>Tonnage</th>
                <th>Temperature Depth</th>
                <th>Daily Without Driver</th>
                <th>Daily With Driver</th>
                <th>Weekly</th>
                <th>Monthly</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td><strong>{row.tonnage}</strong></td>
                  <td>{row.depth}</td>
                  <td>{row.dailyWithout}</td>
                  <td>{row.dailyWith}</td>
                  <td>{row.weekly}</td>
                  <td>{row.monthly}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className="ftfr-pricing-note-box"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <p>{descriptionNote}</p>
        </div>

        <div
          className="ftfr-pricing-actions"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-once="true"
        >
          <a href="tel:+971544792905" className="mini-btn primary">
            Call Now
          </a>
          <a
            href="https://wa.me/971544792905"
            target="_blank"
            rel="noopener noreferrer"
            className="mini-btn secondary-dark"
          >
            WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default FTFRPricing;
